import { AxiosError } from "axios";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import {
  CustomButtonLinkScope,
  CustomButtonLinkTarget
} from "types/landlord/address";
import { getErrorMessage } from "utils/error";

export type PropertyDictionary = ReturnType<
  typeof useUnitsPropertiesDictionary
>;

export const MAX_CUSTOM_BUTTON_LINK_TARGETS = 200;

export const CUSTOM_BUTTON_LINK_TARGETS_PER_PAGE =
  Number(window.localStorage.getItem("per_page")) || 10;

export const targetLabel = (
  count: number,
  scope: CustomButtonLinkScope,
  dictionary: PropertyDictionary
) => {
  if (scope === "property")
    return count === 1 ? dictionary.property : dictionary.properties;

  return count === 1 ? dictionary.unit : dictionary.units;
};

export const getTargetName = (
  target: Pick<CustomButtonLinkTarget, "name">,
  scope: CustomButtonLinkScope,
  dictionary: PropertyDictionary
) => target.name || `Unnamed ${targetLabel(1, scope, dictionary)}`;

export const getApplyErrorMessage = (
  error: unknown,
  scope: CustomButtonLinkScope,
  dictionary: PropertyDictionary
) => {
  if (
    error instanceof AxiosError &&
    error.response?.data?.error?.code === "batch_size_exceeded"
  )
    return `You can apply the link to at most ${MAX_CUSTOM_BUTTON_LINK_TARGETS} ${targetLabel(2, scope, dictionary)} at a time.`;

  return getErrorMessage(error);
};
